// AI and ML work shipped in production, from the resume.

export const AI_PRINCIPLES = [
  "Ground model output in trusted data",
  "Respect authorization and security",
  "Put models behind clear APIs",
  "Measure the business result",
];

export const AI_WORK = [
  {
    company: "Marriott",
    title: "Natural-language search for hotel staff",
    what: "Turns plain questions into authorized searches across reservation, room, and guest data, and returns grounded summaries.",
    outcome: "Staff find operational information without hunting across multiple screens.",
    how: "Authorization-aware and grounded in trusted data.",
  },
  {
    company: "Uber",
    title: "ML pricing, recommendations, and cost forecasting",
    what: "ML-powered pricing and recommendation APIs that surface ride types, pickup times, and promotions, plus Python anomaly detection and forecasts on cloud cost data.",
    outcome: "Higher rider engagement and revenue growth, and less manual analysis for engineers.",
    how: "Models behind APIs, with dashboards that make results visible.",
  },
  {
    company: "Walmart",
    title: "ML review ranking and moderation",
    what: "Python services that bring ML ranking and content classification into the Node.js and GraphQL layer.",
    outcome: "18% more engagement with relevant reviews, abuse flagged automatically, and less manual moderation.",
    how: "Models integrated with the production application layer.",
  },
];
